import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function plural(n, one, other) {
  return `${n || 0} ${(n || 0) === 1 ? one : other}`;
}
